<template>
  <div class="container">
    <div class="col-xs-12">
      <h2 class="sc-navy text-align-center">Unlock the Swisscom Messaging API Products</h2>
    </div>
    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-21 col-xs-offset-3">
          <div class="row">
            <div class="col-xs-12 col-md central-separator central-separator__height">
            </div>
            <div class="col-xs-12 col-md">
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md text-align-right">
              <sdx-button
                  type="button"
                  label="Digital Marketplace Login"
                  @click="dmLogin()"></sdx-button>
              <br/><br/>
              <span class="sc-red">Our Login gets an Update and<br/>is temporary not available!<br/>We apologize for any inconvenience.</span>
            </div>
            <div class="col-xs-2 col-md-1 text-align-center flex-xs-middle central-separator__text">
              OR
            </div>
            <div class="col-xs-12 col-md text-align-left">
              <sdx-button
                  type="button"
                  label="Swisscom Employee Login"
                  icon-name="icon-key"
                  @click="employeeLogin()"></sdx-button>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md padding-v-4 central-separator central-separator__height text-align-right">
              <div class="row">
                <div class="col-md-11">
                  <ul class="margin-bottom-4 text-align-right" style="visibility: hidden">
                    <li class="margin-v-1">
                      <a href="https://digital.swisscom.com/forgotpassword" target="_blank">Forgot your password?</a>
                    </li>
                    <li class="margin-v-1">
                      No account yet? <a href="https://digital.swisscom.com/login" target="_blank">Sign up in Digital
                      Marketplace.</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import envService from "@/services/env.service";

const LOGIN_BASE_URL = envService.getLoginBaseUrl();
const SWISSCOM_SSO_ID = envService.getSwisscomSsoId();
const DM_SSO_ID = envService.geDmSsoId();

export default {


  methods: {
    dmLogin() {
      if (envService.isDevMockEnv()) {
        this.$router.push('/login/' + DM_SSO_ID);
      } else {
        window.location.href = LOGIN_BASE_URL + '/' + DM_SSO_ID;
      }
    },
    employeeLogin() {
      if (envService.isDevMockEnv()) {
        this.$router.push('/login/' + SWISSCOM_SSO_ID);
      } else {
        window.location.href = LOGIN_BASE_URL + '/' + SWISSCOM_SSO_ID;
      }
    }
  },
};
</script>
<style>
.container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.info-text-parent {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}

.central-separator {
  border-right: 1px solid #d6d6d6;
}

.central-separator__text {
  color: #d6d6d6;
}

.central-separator__height {
  height: 100px;
}
</style>
